import { useQuery } from 'data-fetching-client';
import { GET_TASK_STATUS, GET_TASK_STATUS_V2 } from '../../data/queries';
import { captureException } from '../../utils/captureException';
export function useTaskStatus(options = {}) {
  return useQuery(GET_TASK_STATUS, Object.assign({}, options, {
    onError: error => {
      var _options$onError;
      captureException(error, ['useTaskStatus']);
      (_options$onError = options.onError) === null || _options$onError === void 0 || _options$onError.call(options, error);
    }
  }));
}
export function useTaskStatusV2(options = {}) {
  return useQuery(GET_TASK_STATUS_V2, Object.assign({}, options, {
    onError: error => {
      var _options$onError2;
      captureException(error, ['useTaskStatusV2']);
      (_options$onError2 = options.onError) === null || _options$onError2 === void 0 || _options$onError2.call(options, error);
    }
  }));
}